import React, {ReactNode} from "react"
import styled from "styled-components"
import {User} from "@irati/types"
import {Trophy} from "@irati/companyvalues/types"

import ProfilePicGroup from "../../../ProfilePicGroup"
import {LARGE_TROPHY_SIZE} from "../../../ProfilePicWithTrophy"

const ProfileContainer = styled.div`
  position: relative;
  margin: 0 auto;
  height: 150px;
  width: 150px;
`

interface Props {
  children?: ReactNode,
  size: Number,
  users: User[],
  trophy?: Trophy
}

const ModalHeader: React.FC<Props> = ({children, size, users, trophy}) => {
  const singlePictureSize = 150
  const multiplePictureSize = 100

  return (
    <ProfileContainer>
      <ProfilePicGroup
        users={users}
        trophy={trophy}
        trophySize={LARGE_TROPHY_SIZE}
        outerWrapperSize={size}
        innerWrapperSize={size}
        singlePictureSize={singlePictureSize}
        multiplePictureSize={multiplePictureSize}
        isExpanded>
        {children}
      </ProfilePicGroup>
    </ProfileContainer>
  )
}

export default ModalHeader
